import Vue from 'vue'
import Router from 'vue-router'
import Policy from '@/pages/Policy';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import Marketing from '@/pages/Marketing';
import Use from '@/pages/Use';
import Location from '@/pages/Location';
import Card from '@/pages/Card'
import PaymentCaution from '@/pages/PaymentCaution'
import ChallengePrivacy from '@/pages/ChallengePrivacy'
import ChallengeTerms from '@/pages/ChallengeTerms'

import Announcement from '@/pages/Announcement';

import BaroCarePolicy from '@/pages/barocare/Policy'
import BaroCarePrivacy from '@/pages/barocare/Privacy'
import BaroCareTerms from '@/pages/barocare/Terms'
import BaroCareUse from '@/pages/barocare/Use'

import Home from '@/pages/holiday/Home'

// 테라젠 이용동의 
import Genetic from '@/pages/genetic/Genetic'
import GeneticAgreement from '@/pages/genetic/Agreement';
import GeneticUse from '@/pages/genetic/Use';
import GeneticProvide from '@/pages/genetic/Provide';
import GeneticSensitiveThirdPartyContent from '@/pages/genetic/SenstiveThirdPartyContent';
import GeneticPrivacyThirdPartyContent from '@/pages/genetic/PrivacyThirdPartyContent';

// 개인정보 
import SignUp from '@/pages/privacy/SignUp';
import Payment from '@/pages/privacy/Payment';
import Profile from '@/pages/privacy/Profile';

// 혁신의료기술 동의서
import Innovation from '@/pages/innovation/Agreement';
import AddPrivacyUse from '@/pages/innovation/AddPrivacyUse.vue';

// 파트너스
import PartnerPolicy from '@/pages/partners/Policy';
import PartnerTerms from '@/pages/partners/Terms';
import PartnerPrivacy from '@/pages/partners/Privacy';
import PartnerUse from '@/pages/partners/Use';
import PartnerContract from '@/pages/partners/Contract';
import PartnerMarketing from '@/pages/partners/Marketing';
import PartnerAdvertisement from '@/pages/partners/Advertisement';
import Sensitive from '@/pages/barocare/Sensitive';

// 건강정보
import HealthConsent from '@/pages/health/HealthConsent';
import ThirdPartyConsent from '@/pages/health/ThirdPartyConsent';
import SensitiveInfoConsent from '@/pages/health/SensitiveInfoConsent';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/card',
      name: 'card',
      component: Card
    },
    {
      path: '/',
      name: 'policy',
      component: Policy,
      children: [
        {
          path: 'privacy',
          name: 'privacy',
          component: Privacy
        },
        {
          path: 'terms',
          name: 'terms',
          component: Terms
        },
        {
          path: 'marketing',
          name: 'marketing',
          component: Marketing
        },
        {
          path: 'use',
          name: 'use',
          component: Use
        },
        {
          path: 'location',
          name: 'location',
          component: Location
        },
        {
          path: 'challenge-privacy',
          name: 'challenge-privacy',
          component: ChallengePrivacy
        },
        {
          path: 'challenge-terms',
          name: 'challenge-terms',
          component: ChallengeTerms
        },
        {
         path: '/payment-caution',
         name: 'payment-caution',
         component: PaymentCaution
        },
        {
          path: '/health-consent',
          name: 'health-consent',
          component: HealthConsent
        },
        {
          path: '/third-party-consent',
          name: 'third-party-consent',
          component: ThirdPartyConsent
        },
        {
          path: '/sensitive-info-consent',
          name: 'sensitive-info-consent',
          component: SensitiveInfoConsent
        }
      ]
    },
    
    {
      path: '/partners',
      name: 'partners',
      component: PartnerPolicy,
      children: [
        { path: 'terms', name: 'terms', component: PartnerTerms},
        { path: 'privacy', name: 'privacy', component: PartnerPrivacy},
        { path: 'use', name: 'use', component: PartnerUse},
        { path: 'contract', name: 'contract', component: PartnerContract},
        { path: 'marketing', name: 'marketing', component: PartnerMarketing},
        { path: 'advertisement', name: 'advertisement', component: PartnerAdvertisement},
      ]
    },
    {
      path:'/privacy-consent/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path:'/privacy-consent/payment',
      name: 'payment',
      component: Payment
    },
    {
      path:'/privacy-consent/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/innovation',
      name: 'innovation',
      component: Innovation
    },
    {
      path: '/innovation-use',
      name: 'innovation-use',
      component: AddPrivacyUse
    },
    {
      path: '/genetic',
      name: 'genetic',
      component: Genetic,
      children: [
        {
          path: 'agreement',
          name: 'agreement',
          component: GeneticAgreement
        },
        {
          path: 'use',
          name: 'use',
          component: GeneticUse
        },
        {
          path: 'provide',
          name: 'provide',
          component: GeneticProvide
        },
        {
          path: 'sensitive-thirdparty-consent',
          name: 'sensitive-thirdparty-consent',
          component: GeneticSensitiveThirdPartyContent
        },
        {
          path: 'privacy-thirdparty-consent',
          name: 'privacy-thirdparty-consent',
          component: GeneticPrivacyThirdPartyContent
        }
      ]
    },
    {
      path: '/barocare',
      name: 'barocare',
      component: BaroCarePolicy,
      children: [
        {
          path: 'privacy',
          name: 'privacy',
          component: BaroCarePrivacy
        },
        {
          path: 'terms',
          name: 'terms',
          component: BaroCareTerms
        },
        {
          path: 'use',
          name: 'use',
          component: BaroCareUse
        }
      ]
    },
    {
      path: '/barocare-sensitive',
      name: 'barocare-sensitive',
      component: Sensitive
    },
    {
      path: '/announcement/:id',
      name: 'announcement',
      component: Announcement
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js